import React, { Component } from "react";
import styled from "styled-components";

import log from "js/core/logger";

import Waveform from "../Waveform";

import { AssetType } from "common/constants";
import { ds } from "js/core/models/dataService";

const AudioLineContainer = styled.div`
    position: relative;
    background: #333;
    height: 40px;   
    width: 100%;
    color: #ffffff;
`;

const WaveformContainer = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 40px;
    display: block;
    overflow: hidden;
    z-index: 0;
`;

export class AudioLine extends Component {
    constructor(props) {
        super(props);

        this.state = {
            audioUrl: null
        };

        this.containerRef = React.createRef();
    }

    get isProcessingAudio() {
        const { isImportingAudio, isRecordingAudio } = this.state;
        return isImportingAudio || isRecordingAudio;
    }

    get containerWidth() {
        return this.containerRef.current.getBoundingClientRect().width;
    }

    componentDidMount() {
        this.loadAudio()
            .catch(err => {
                log.error("[AudioLine] failed to load audio");
                log.error(err);
            });
    }

    loadAudio = async () => {
        const { canvas } = this.props;

        // Make sure we refresh w/o audioUrl to unmount the Waveform
        // component
        await new Promise(resolve => this.setState({ audioUrl: null }, resolve));

        const audioAssetId = canvas.dataModel.get("audioAsset");
        if (!audioAssetId) {
            return;
        }

        const asset = await ds.assets.getAssetById(audioAssetId, AssetType.AUDIO);
        const audioUrl = await asset.getBaseUrl();
        this.setState({ audioUrl });
    }

    render() {
        const { animationsDuration } = this.props;
        const { audioUrl } = this.state;

        return (<AudioLineContainer ref={this.containerRef}>
            {audioUrl &&
                <WaveformContainer>
                    <Waveform
                        src={audioUrl}
                        height={40}
                        waveColor="#11a9e2"
                        cursorColor="#11a9e2"
                        interact={false}
                        fillParent={false}
                        minPxPerSec={this.containerWidth / animationsDuration * 1000}
                    />
                </WaveformContainer>
            }
        </AudioLineContainer >);
    }
}
